import React, { useState } from "react";
import { Container } from "./Styled";
import IntentList from "./IntentList/IntentList";
import IntentForm from "./IntentForm/IntentForm";
import { Intent } from "../../../model/intent/types";
import ItemManager from "../../system/itemManager/ItemManager";
const IntentItemManager = ItemManager<Intent>();

type IntentFormProps = {};

const IntentManager: React.FunctionComponent<IntentFormProps> = props => {
  const [selectedIntent, setSelectedIntent] = useState<Intent | undefined | null>(null);

  const renderMenu = () => {
    return <IntentList selectedIntentId={selectedIntent?.id} onSelect={(intent?: Intent | null) => setSelectedIntent(intent)}/>
  }

  const renderContent = () => {
    return <IntentForm intent={selectedIntent}/>
  }

  return (
    <Container>
        <IntentItemManager
          Menu={renderMenu()}
          Content={renderContent()}
          selectedItem={selectedIntent}
        />
    </Container>
  );
};

export default IntentManager;
